module.exports = __webpack_public_path__ + "img/WLGravity-logo.53229a78.svg";